import React from 'react';
import { Spinner } from 'reactstrap';

const LoadingSpinner = () => (
  <h3 className="page-subhead subhead text-center" style={{ display: 'flex', justifyContent: 'center' }}>
    <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
  </h3>
);

export default LoadingSpinner;
